import React from "react";

import styles from "./financeCardChart.module.css";

const FinanceCardChart = ({ children, title, code, height }) => {
  return (
    <div className={styles.financeInvoicingContent} style={height ? { height } : undefined}>
      {code && <span className={styles.code}>{code}</span>}
      <h4 className={styles.title}>{title}</h4>

      {children}
    </div>
  );
};

export default FinanceCardChart;
